import { useState } from "react";
import SafeleaseDataGrid from "../../../shared/safelease-data-grid";
import { GridRowParams } from "@mui/x-data-grid-premium";
import { fmsActivityTableColumnDefs } from "./fmsActivityDefinitions";
import { FmsActivityDialog } from "./FmsActivityDialog";
import { fmsReportsApi } from "../../../utilities/apiInstances/fms-reports.api";
import { useQuery } from "@tanstack/react-query";

interface FmsActivityTableProps {
  startServicePeriod: Date;
}

function FmsActivityTable({ startServicePeriod }: FmsActivityTableProps) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const { data: locationRows } = useQuery({
    queryKey: ["fms-report-locations"],
    queryFn: () => fmsReportsApi.getLocations(),
  });

  const handleRowClick = (params: GridRowParams) => {
    setSelectedLocation(params.row);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <SafeleaseDataGrid
        autosizeOnMount
        disableRowSelectionOnClick
        columns={fmsActivityTableColumnDefs}
        rows={locationRows || []}
        onRowClick={handleRowClick}
        clickable
      />
      <FmsActivityDialog
        open={dialogOpen}
        handleClose={handleDialogClose}
        selectedLocation={selectedLocation}
        startServicePeriod={startServicePeriod}
      />
    </>
  );
}

export { FmsActivityTable };
